import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiUser } from 'react-icons/fi';
import { useMsal } from '@azure/msal-react';
import { getMenu } from '../../Layout.constants.ts';

import { CgMenuLeftAlt } from 'react-icons/cg';

import logo from '../../../../assets/icons/logo.svg';

import MobileMenu from '../mobile-menu/MobileMenu.tsx';
import './TopBar.styles.css';
import { Spin } from 'antd';
import { usePermissions } from '../../../../hooks/usePermissions.ts';
import { useQuery } from '@tanstack/react-query';
import { fetchEmail } from '../../../../pages/dashboard/Dashboard.services.ts';

const FullscreenLoader = () => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 9999,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 1)', // Optional semi-transparent background
      }}
    >
      <Spin size="large" tip="Loading..." />
    </div>
  );
};

export default function TopBar() {
  const { accounts } = useMsal();
  const [showMobileMenu, setShowMobileMenu] = useState<boolean>(false);
  const { data: email } = useQuery({
    queryKey: ['email'],
    queryFn: fetchEmail,
    retry: false,
  });

  const handleShowMobileMenu = () => setShowMobileMenu(true);
  const handleCloseMobileMenu = () => setShowMobileMenu(false);
  const { isAdmin } = usePermissions(0);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const menu = isAdmin
    ? getMenu({ email })
    : getMenu({ email }).filter((item: { key: number }) => item.key !== 5);

  if (!accounts[0]?.username) {
    return <FullscreenLoader />;
  }

  return (
    <>
      <div className="topbar-container">
        <div className="logo">
          <img src={logo} alt="logo" />
          <div className="mobile-menu" onClick={handleShowMobileMenu}>
            <CgMenuLeftAlt color="var(--primary-color)" size="24px" />
          </div>
        </div>
        <div className="menu">
          {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment*/}
          {/* @ts-ignore*/}
          {menu.map((item) => (
            <Link key={item.name} to={item.path}>
              <div className="menu-item">{item.name}</div>
            </Link>
          ))}
        </div>
        <div className="user">
          <FiUser fontSize={20} />
          <span>{accounts[0]?.username ? accounts[0]?.username : <FullscreenLoader />}</span>
        </div>
      </div>
      <MobileMenu open={showMobileMenu} onClose={handleCloseMobileMenu} />
    </>
  );
}
